var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 21.75C25.7541 17.7459 25.7541 11.2541 21.75 7.25C17.7459 3.24593 11.2541 3.24593 7.25 7.25C3.24594 11.2541 3.24593 17.7459 7.25 21.75C11.2541 25.7541 17.7459 25.7541 21.75 21.75Z",
    fill: "#00CEBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3649 11.3806C25.815 9.28317 24.7114 7.36115 23.1734 5.82273C20.8557 3.50512 17.7741 2.22883 14.4967 2.22883C11.2193 2.22883 8.13764 3.50512 5.82003 5.82273C4.28201 7.36115 3.17834 9.28277 2.62851 11.3802L2.21094 11.2707C2.77995 9.09896 3.92278 7.10981 5.51474 5.51745C7.91387 3.11832 11.1038 1.79688 14.4967 1.79688C17.8896 1.79688 21.0795 3.11832 23.4786 5.51745C25.071 7.10981 26.2138 9.09936 26.7829 11.2711L26.3653 11.3806H26.3649Z",
    fill: "#00CEBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3472 11.1015C27.4503 11.5374 27.1802 11.9746 26.7442 12.0777C26.3083 12.1808 25.8711 11.9106 25.768 11.4747C25.6649 11.0387 25.9351 10.6016 26.371 10.4985C26.807 10.3954 27.2441 10.6655 27.3472 11.1015Z",
    fill: "#00CEBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64303 11.1015C1.53994 11.5374 1.81006 11.9746 2.24601 12.0777C2.68196 12.1808 3.11911 11.9106 3.22221 11.4747C3.3253 11.0387 3.05518 10.6016 2.61923 10.4985C2.18328 10.3954 1.74613 10.6655 1.64303 11.1015Z",
    fill: "#00CEBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4986 27.1998C11.1057 27.1998 7.91577 25.8783 5.51664 23.4792C3.96064 21.9232 2.831 19.9828 2.25 17.8682L2.66597 17.7539C3.22699 19.7966 4.31827 21.6707 5.82152 23.1739C8.13914 25.4915 11.2208 26.7678 14.4982 26.7678C17.7756 26.7678 20.8573 25.4915 23.1749 23.1739C24.6781 21.6707 25.7694 19.7962 26.3304 17.7539L26.7464 17.8682C26.1658 19.9824 25.0361 21.9228 23.4797 23.4788C21.0806 25.8779 17.8907 27.1994 14.4978 27.1994L14.4986 27.1998Z",
    fill: "#00CEBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6842 18.0457C1.57631 17.6109 1.84164 17.171 2.27639 17.0631C2.71115 16.9552 3.15109 17.2205 3.25898 17.6553C3.36687 18.0901 3.10154 18.53 2.66679 18.6379C2.23204 18.7458 1.79209 18.4805 1.6842 18.0457Z",
    fill: "#00CEBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3098 18.0457C27.4176 17.6109 27.1523 17.171 26.7176 17.0631C26.2828 16.9552 25.8429 17.2205 25.735 17.6553C25.6271 18.0901 25.8924 18.53 26.3272 18.6379C26.7619 18.7458 27.2019 18.4805 27.3098 18.0457Z",
    fill: "#00CEBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8133 9.71094L12.6348 15.8894L10.1889 13.4435L8.48828 15.1437L12.6348 19.2903L20.5139 11.4116L18.8133 9.71094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOffer);
export default __webpack_public_path__ + "static/media/checkOffer.30003dd76927fc9e47c3834902ed24cb.svg";
export { ForwardRef as ReactComponent };